





import { Component, Vue } from 'vue-property-decorator';
import StyledSelectDefaultView from './StyledSelectDefaultView.vue';

/**
 * Abstracts animation of height for elements that should slide in when shown. This is necessary because CSS doesn't
 * support transitions on height if the 'auto' special value is involved (for some reason).
 */
@Component({
  components: {StyledSelectDefaultView},
})
export default class SmoothShow extends Vue {
  public enter(element: HTMLElement) {
    const contentHeight = this.calculateContentHeightOffScreen(element);
    this.resetOffScreenSetup(element);
    this.setExplicitFinalHeightForCssAnimation(element, contentHeight);
  }

  public afterEnter(element: HTMLElement) {
    element.style.height = 'auto'; // if element height changes after show
  }

  public leave(element: HTMLElement) {
    this.setExplicitOriginalHeightForCssAnimation(element);
    this.setExplicitFinalHeightForCssAnimation(element, '0');
  }

  private calculateContentHeightOffScreen(element: HTMLElement): string {
    element.style.width = getComputedStyle(element).width;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.height = 'auto';
    return getComputedStyle(element).height;
  }

  private resetOffScreenSetup(element: HTMLElement) {
    element.style.removeProperty('width');
    element.style.removeProperty('position');
    element.style.removeProperty('visibility');
    element.style.height = '0';
  }

  private setExplicitFinalHeightForCssAnimation(element: HTMLElement, contentHeight: string) {
    this.forceRepaint(element);
    setTimeout(() => {
      element.style.height = contentHeight;
    });
  }

  private forceRepaint(element: HTMLElement) {
    // tslint:disable-next-line no-unused-expression
    getComputedStyle(element).height;
  }

  private setExplicitOriginalHeightForCssAnimation(element: HTMLElement) {
    element.style.height = getComputedStyle(element).height;
  }
}
